import React from "react";

export const TickIcon = () => (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" aria-hidden="true" style={{ flexShrink: 0, marginTop: 4 }}>
    <path
      data-tick-icon-path
      d="M4 9.4L0 5.4L1.4 4L4 6.6L10.6 0L12 1.4L4 9.4Z"
      fill="currentColor"
    />
  </svg>
);
